module.exports = __webpack_public_path__ + "img/bhlyzng.ddb426c4.jpg";